import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { STRUCTURE_TOKENS } from "./structure-types";

/**
 * Sidebar palette for adding new structures + beds to the garden map.
 * Each click immediately creates the item at the centre of the map and the
 * parent persists it via the API.
 */
export function StructurePalette({ onAddStructure, onAddBed }) {
    return (
        <aside
            data-testid="garden-map-palette"
            className="rounded-lg border border-[var(--vm-border)] bg-[var(--vm-card)] p-4 w-full lg:w-64 shrink-0"
        >
            <div className="overline text-[var(--vm-sage)] mb-3">Add to garden</div>

            <Button
                onClick={onAddBed}
                data-testid="add-bed-from-map"
                className="w-full justify-start mb-2 rounded-full bg-[var(--vm-accent)] hover:bg-[var(--vm-accent-hover)] text-[var(--vm-bg)]"
            >
                <Plus className="w-3.5 h-3.5 mr-2" /> Bed
            </Button>

            <div className="text-[10px] uppercase tracking-wider text-[var(--vm-text-muted)] mt-4 mb-2">Structures</div>
            <div className="space-y-1.5">
                {Object.entries(STRUCTURE_TOKENS).map(([type, token]) => {
                    const Icon = token.icon;
                    return (
                        <button
                            key={type}
                            type="button"
                            onClick={() => onAddStructure(type)}
                            data-testid={`add-structure-${type}`}
                            className={`w-full flex items-center gap-2 px-3 py-2 rounded-md border text-sm hover:brightness-95 transition-colors ${token.bg} ${token.border} ${token.text}`}
                        >
                            <Icon className="w-3.5 h-3.5 shrink-0" strokeWidth={1.5} />
                            <span>{token.label}</span>
                        </button>
                    );
                })}
            </div>

            <p className="text-[10px] text-[var(--vm-text-muted)] mt-4 leading-relaxed">
                Click to add. Drag any item to position. Click again to edit details.
            </p>
        </aside>
    );
}
